import * as _ from "lodash";
import { LeaseRegistry } from "./LeaseRegistry";
import { PAWebSocketClient } from "../PA.Core/PAWebSocketClient";
import * as AGChannel from "ag-channel";

export const LeaseServerChannelId = "PALeaseServer";

export interface ILeaseServerMessage {
    requestName: string;
    classList?: string[];
    options?: any;
}

export class LeaseServer {
    private _socket: PAWebSocketClient;
    private _channel: AGChannel<ILeaseServerMessage>;
    private _setupPromise: Promise<void>;

    constructor() {
        const self = this;

        const socket = new PAWebSocketClient();
        self._socket = socket;

        self._setupPromise = self.setupChannelEventHandlers();
    }

    private async setupChannelEventHandlers(): Promise<void> {
        const self = this;
        const channel = await self._socket.getChannel(LeaseServerChannelId);
        channel.subscribe({});
        self._channel = channel;

        (async () => {
            for await (const msg of self._channel) {
                try {
                    const requestName = msg?.requestName;
                    switch (requestName) {
                        case "resetFunction":
                            //-- console.log("LeaseServer: resetFunction msg received: ", msg)
                            const classList = msg?.classList || [];
                            if (_.isArray(classList)) {
                                LeaseRegistry.invalidateLeasesByClassList(classList);
                            }
                            break;
                        default:
                            console.log("Unknown Message on Lease Channel: ", msg);
                    }
                } catch (err) {
                    console.log("LeaseServer: error handling message: ", msg, " error: ", err);
                }
            }
        })();
    }

    public async broadcastResetLeaseClass(classList: string[] | string): Promise<void> {
        if (_.isString(classList)) {
            classList = [classList];
        }
        console.log(`${new Date().toUTCString()} - Broadcasting ResetLeaseClass:  ${classList}`);

        await this._setupPromise;

        const msg: ILeaseServerMessage = {
            requestName: "resetFunction",
            classList: classList,
            options: {},
        };
        await this._channel.invokePublish(msg);
    }
}
